import React from "react";
import { Link } from "react-router-dom";

// --- contact images ---
import img01 from "../../images/contact/1.png"; // 🇹🇷 Istanbul
import img02 from "../../images/contact/2.png"; // 🇮🇳 India

// --- arrow icons ---
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";

// ---- contact items data ----
const contactData = [
  {
    location: "Noida ,India",
    address: "A-44 & 45, Galaxy Business Park, Sushil Marg, Block A, Industrial Area, Sector 62, Noida, Noida, Gautambuddha Nagar, Uttar Pradesh, 201309",
    email: "business@comcodes.io",
    img: img01,
    mapUrl:
      "https://www.google.com/maps/place/COMCODES+DIGITAL+SERVICES/@28.6074002,77.4312021,17z/data=!3m1!4b1!4m6!3m5!1s0x390cefc8f3b5af19:0x6cffc773322f5537!8m2!3d28.6074002!4d77.433777!16s%2Fg%2F11xp72ps1v",
  },
  {
    location: "Zirakpur ,India",
    address:
      "Motiaz Royal Business Park, 2nd Floor, Zirakpur, Punjab, Mohali, 160055",
    email: "business@comcodes.io",
    img: img02,
    mapUrl:
      "https://www.google.com/maps/place/Comcodes/@30.6328155,76.8247036,17z",
  },
];


const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <div className="container">
        <div className="row mt-none-30">
          {contactData.map((item, index) => (
            <div className="col-lg-6 col-md-6 mt-30" key={index}>
              <div
                className="xb-contact-items img-hove-effect xb-border"
                style={{ height: "100%", display: "flex", flexDirection: "column" }}
              >
                <div
                  className="xb-item--inner"
                  style={{ height: "100%", display: "flex", flexDirection: "column" }}
                >
                  {/* Hover Images */}
                  <div className="xb-img">
                    <Link to="/contact"><img src={item.img} alt={item.location} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.location} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.location} /></Link>
                    <Link to="/contact"><img src={item.img} alt={item.location} /></Link>
                  </div>

                  {/* Content */}
                  <div
                    className="xb-item--holder"
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p className="xb-item--location">{item.location}</p>

                    <span className="xb-item--contact_info">
                      {item.address}
                    </span>

                    {/* Bottom group */}
                    <div style={{ marginTop: "auto" }}>
                      <span
                        className="xb-item--contact_info"
                        style={{ display: "block", marginBottom: 12 }}
                      >
                        {item.email}
                      </span>

                      <a
  href={item.mapUrl}
  target="_blank"
  rel="noopener noreferrer"
  className="thm-btn form-btn"
>
  VIEW LOCATION
  <span className="xb-icon">
    <img src={arrowWhite} alt="icon" />
    <img src={arrowBlack} alt="icon" />
  </span>
</a>

                    </div>
                  </div>

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
